import { City, Street } from '@kamernet/core/ApiClient/Kamernet';

export interface LocationSlugsValidationResult {
  isValid: boolean;
  city: City | null;
  street: Street | null;
}

export function validateLocationSlugs(
  citySlug: string | null,
  streetSlug: string | null,
  cities: City[],
  streets: Street[],
): LocationSlugsValidationResult {
  const invalidResult: LocationSlugsValidationResult = {
    isValid: false,
    city: null,
    street: null,
  };

  const city = cities.find(item => item.slug === citySlug);

  if (streetSlug) {
    if (!city) {
      return invalidResult;
    }

    const street = streets.find(
      item => item.cityId === city.id && item.slug === streetSlug,
    );

    if (!street) {
      return invalidResult;
    }

    return { isValid: true, city, street };
  }

  if (city) {
    return { isValid: true, city, street: null };
  }

  if (!citySlug && !city) {
    return { isValid: true, city: null, street: null };
  }

  return invalidResult;
}
